import React, { useState } from "react";
import Image from "components/image/image.component";
import { BiArrowToLeft, BiArrowToRight } from "react-icons/bi";
import { MdClear, MdDelete } from "react-icons/md";
import styled from "styled-components";

export const ImageComponent = styled.div`
  margin: 10px 0;
  position: relative;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  padding: 0.1rem 0.3rem;
  display: flex;
  border-radius: 20px 20px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

interface SendImageCompProp {
  selectedImages: File[];
  deleteImage: (index: number) => void;
  clearImages: () => void;
}

const SendImageComponent: React.FC<SendImageCompProp> = ({
  selectedImages,
  deleteImage,
  clearImages,
}) => {
  const [currentIndex, setIndex] = useState<number>(0);
  const showRight =
    selectedImages.length > 1 && currentIndex !== selectedImages.length - 1;
  const showLeft = currentIndex !== 0;
  const circle =
    "bg-black w-8 h-8 p-1 rounded-full flex justify-center items-center text-white cursor-pointer";

  const next = () => {
    if (currentIndex < selectedImages.length - 1) {
      const index = currentIndex + 1;
      setIndex(index);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      const index = currentIndex - 1;
      setIndex(index);
    }
  };

  return (
    <div className="relative w-full h-full flex justify-center items-center shadow bg-white dark:bg-casagray-900">
      <ImageComponent>
        <Image
          key={currentIndex}
          src={URL.createObjectURL(selectedImages[currentIndex])}
          alt={`img-${currentIndex}`}
          // className="w-full h-full rounded-lg p-2 rounded-box mt-6 mb-6"
          // style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </ImageComponent>
      <div
        className={`absolute flex ${
          showLeft && showRight
            ? "justify-between"
            : showLeft
            ? "justify-start"
            : "justify-end"
        } w-full items-center h-full top-10`}
      >
        {showLeft && (
          <BiArrowToLeft className={circle} fill="white" onClick={prev} />
        )}
        {showRight && (
          <BiArrowToRight
            className={circle}
            fill="white"
            onClick={next}
            style={{
              justifyContent: `${currentIndex === 0 ? "flex-end" : ""}`,
            }}
          />
        )}
      </div>
      <div className="absolute flex justify-between w-full h-4 top-2">
        <MdClear className={circle} fill="white" onClick={clearImages} />
        <MdDelete
          className={circle}
          fill="white"
          onClick={() => {
            deleteImage(currentIndex);
            if (currentIndex !== 0) {
              setIndex(currentIndex - 1);
            }
          }}
        />
      </div>
    </div>
  );
};

export default SendImageComponent;
